import axios from "axios";
import {navigate} from "gatsby-link";
import {closeDialog,showLoading,Util} from "baziigram";
import {GetUser} from "./user"
import {dictionary} from "../constants"

let inProgrss = false;
let queue = [];

class Client {
    constructor(
        baseUrl,
        defaultBody,
        defaultHeader,
        updateToken,
        timeout,
        options,
    ) {
        timeout = timeout || 40000;
        this.client = axios.create({
            baseURL: baseUrl,
            timeout: timeout,
            withCredentials: false,
            header: Object.assign({}, defaultHeader),
            insecure: true,
            data: Object.assign({}, defaultBody),
        });

        this.options = options;
        this.defaultBody = Object.assign({}, defaultBody);
        this.refreshToken = updateToken;
            this.registerUnAuthorizeInterceptor(updateToken);


    }


    async post(url, body, header) {
        let req;
        let headers = await this.getHeader(header, url, body);
        if (!headers["Content-Type"])
            headers["Content-Type"] = "application/json";

        req = this.client.post(url, body, { headers }).catch(err => err);
        return req;
    }

    async put(url, body, header) {
        let req;
        let headers = await this.getHeader(header, url, body);
        if (!headers["Content-Type"])
            headers["Content-Type"] = "application/json";

        req = this.client.put(url, body, { headers }).catch(err => err);
        return req;
    }

    async patch(url, body, header) {
        let req;
        let headers = await this.getHeader(header, url, body);
        if (!headers["Content-Type"])
            headers["Content-Type"] = "application/json";

        req = this.client.patch(url, body, { headers }).catch(err => err);
        return req;
    }

    async deleteWithQueryPart(url, body, header) {
        let req;
        let headers = await this.getHeader(header, url, body);
        req = this.client
            .delete(url + this.createQueryPart(body), { headers })
            .catch(err => err);
        return req;
    }

    async deleteWithBody(url, body, header) {
        let req;
        let headers = await this.getHeader(header, url, body);
        headers["Content-Type"] = "application/json";
        req = this.client
            .delete(url, { headers: headers, data: body })
            .catch(err => err);
        return req;
    }

    async get(url, body, header) {
        let req;
        let headers = await this.getHeader(header, url, body);
        req = this.client
            .get(url + this.createQueryPart(body), {
                headers: headers,
                data: body,
            })
            .catch(err => err);
        return req;
    }

    createQueryPart(params) {
        if (
            params != null &&
            params != undefined &&
            Object.keys(params).length > 0
        ) {
            let str = "?";
            let keysLength = Object.keys(params).length;
            Object.keys(params).map((key, i) => {
                if (params[key] != null) str += key + "=" + params[key];
                if (i < keysLength - 1) str += "&";
            });

            return str;
        }

        return "";
    }

    async getHeader(header, url, body = null) {
        let token = GetUser().accessToken;
        let auth = { Authorization: "Bearer " + token  };
        let sign = {};
        let language = {Language:Util.getLanguage()};
        return Object.assign({}, sign , language, auth, this.client.headers, header);
    }

   static unAuthorizationHandler(error,updateToken){

          if (!inProgrss && updateToken) {
               inProgrss = true;
                updateToken(error, 3 , 3000)
         }
          return new Promise(function (resolve, reject) {
                                queue.push({
                                resolve,
                                reject,
                                request: error.config,
                               });
                     });
    }

    registerUnAuthorizeInterceptor(updateToken) {
    let language = Util.getLanguage()
        this.client.interceptors.response.use(
            function (response) {
            if(response.data && response.data.code==401)
             Client.unAuthorizationHandler(response,updateToken);

             return response;
            },
            async error => {
                if (updateToken) {
                    let body = {}
                    if (error.config.data!= undefined){
                        try{body = JSON.parse(error.config.data)}
                        catch (err) {
                        }
                    }
                    if (
                        error.config &&
                        error.response && error.response.status == 401
                      )
                    return  Client.unAuthorizationHandler(error , updateToken);

                } else if (error.response && error.response.status == 500) {
                    error.message = dictionary.serverError[language]
                    Promise.reject(error);
                }

                return Promise.reject(
                    new Error(
                        Object.keys(error.response.data).length > 0
                            ? error.response.data.message
                            : error
                    )
                );
            }
        );
    }

    proccessQueue = (token = null ) => {
        if (queue && queue.length > 0) {
            queue.forEach(prom => {
                let body =
                    prom.request.data != undefined
                        ? JSON.parse(prom.request.data)
                        : {};
                if (prom.request.headers) {
                    prom.request.headers["Authorization"] = "Bearer " + token;
                }

                this.client
                    .request(prom.request)
                    .then(res => {
                        prom.resolve(res);
                    })
                    .catch(err => {
                        prom.reject(new Error(
                            Object.keys(err.response.data).length > 0
                                ? err.response.data.message
                                : err
                        ));
                    });
            });

        }
        inProgrss = false;
        queue = [];
    };
}

export default Client;

